import React, { Suspense, lazy } from 'react'
import { ErrorBoundary } from '../components/common/ErrorBoundary'
import { Helmet } from 'components/common/Helmet'
import { Loading } from 'ui'

export const Inventory = () => {
  const InventorySearch = lazy(() =>
    import('components/inventorySearch/InventorySearch'),
  )

  return (
    <ErrorBoundary>
      <Helmet title="Inventory" />
      <Suspense fallback={<Loading />}>
        <InventorySearch />
      </Suspense>
    </ErrorBoundary>
  )
}
